import styled, {css} from "styled-components"

const SortPopupBox = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  z-index: 999;
  ${({theme}) => css`
    margin-top: ${theme.spacing.one};
    border-radius: ${theme.border.radius.small};
    background-color: ${theme.colors.utility.white};
    box-shadow: ${theme.shadows.low};
  `}
`

export default SortPopupBox
